const v = {
  name: "OfficeChair",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28,0H8v16h9v5H8v2H4v-2h2V10H0v11h2v4h6v2h9v3H2v4.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3
			c0-1.3-0.8-2.4-2-2.8V32h13v2.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V32h13v2.2
			c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V30H19v-3h9v-2h6v-4h2V10h-6v11h2v2h-4v-2h-9v-5h9V0z
			 M10,14V2h16v12H10z M10,25v-2h16v2H10z M2,12h2v7H2V12z M32,19v-7h2v7H32z M17,37c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1
			S17,37.6,17,37z M3,36c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.6,0-1-0.4-1-1S2.4,36,3,36z M32,37c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1
			S32,37.6,32,37z"/>
	</g>
</g>
</svg>
  `
};
export {
  v as OfficeChair
};
